export default __webpack_public_path__ + "static/media/TriggerWebhook.e30b2028.svg";